import { render } from "./FeedbackPanelPage.vue?vue&type=template&id=bf9d8e76"
import script from "./FeedbackPanelPage.vue?vue&type=script&lang=js"
export * from "./FeedbackPanelPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__